import React, { useState } from "react";
import { Col, Card, CardHeader, CardBody, CardText, Button } from "reactstrap";
import Information_technology from './../../assets/Information Technology.png';
import AutoCAD from './../../assets/AutoCAD.png';
import EnglishCommunication from './../../assets/English Communication & Soft Skil.png';
import FinancialAccounting from './../../assets/Financial Accounting.png';
import AdvancedExcel from './../../assets/Advanced Excel.png';
import advanceAccounting from './../../assets/Advanced Accounting.png';
import ITDesktop from './../../assets/IT Desktop &  Hardware Support.png';
import ITNetwork from './../../assets/IT Network Support.png';
import ITSecurity from './../../assets/IT Security Support.png';
import PhotoEditing from './../../assets/Photo Editing.png';
import VideoEditing from './../../assets/Video Editing.png';
import GraphicDesigning from './../../assets/Graphic Designing.png';
import CorelDraw from './../../assets/Corel Draw 1.png';
import adobeDTP from './../../assets/Adobe.png';
import WebDesigning from './../../assets/Web Designing.png';
import OfficeAssistance from './../../assets/Office Assistance.png';
import CProgramming from './../../assets/C & C++ Programming.png';
const CourseCard = () => {
  const [iframeSrc, setIframeSrc] = useState(""); // State to manage iframe source

  const courses = [

    {
      title: "Certificate in Information Technology (HS-CIT)",
      duration: "132",
      nsqfLevel: "3",
      qpCode: "2019/ITES/HKCL/3552",
      link: "",
      image: Information_technology,
    },
    {
      title: "HS-CIT (A) [Haryana State Certificate in IT Applications]",
      duration: "6 Months",
      nsqfLevel: "4",
      qpCode: "2019/ITES/HKCL/3555",
      link: "",
      image: CProgramming,
    },
    {
      title: "HS-CIT (A+) [Haryana State Certificate in IT Advanced App.]",
      duration: "1 Year",
      nsqfLevel: "3",
      qpCode: "2019/ITES/HKCL/3552",
      link: "",
      image: Information_technology,
    },

    {
      title: "Certificate in English Communication & Soft Skills",
      duration: "120",
      nsqfLevel: "3",
      qpCode: "2019/OAFM/HKCL/3548",
      link: "https://hkcl.in/University/hcoc_english_comm.php",
      image: EnglishCommunication,
    },


    {
      title: "Certificate in Advanced Accounting",
      duration: "120",
      nsqfLevel: "4",
      qpCode: "2019/BFSI/HKCL/3550",
      link: "https://hkcl.in/University/hcoc_advanced_accounting.php",
      image: advanceAccounting,
    },

    {


      title: " Certificate in Financial  Accounting",
      duration: "120",
      nsqfLevel: "3",
      qpCode: "2019/BFSI/HKCL/3551",
      link: "https://hkcl.in/University/hcoc_financial_accounting.php",
      image: FinancialAccounting,
    },



    {
      title: "Certificate in Advanced Excel",
      duration: "120",
      nsqfLevel: "4",
      qpCode: "2019/ITES/HKCL/3553",
      link: "https://hkcl.in/University/hcoc_advanced_excel.php",
      image: AdvancedExcel,
    },




    {
      title: "Certificate in IT Network Support",
      duration: "120",
      nsqfLevel: "3",
      qpCode: "2019/ITES/HKCL/3557",
      link: "https://hkcl.in/University/hcoc_network_support.php",
      image: ITNetwork,
    },

    {
      title: "Certificate in IT Security Support",
      duration: "120",
      nsqfLevel: "3",
      qpCode: "2019/ITES/HKCL/3558",
      link: "https://hkcl.in/University/hcoc_security_support.php",
      image: ITSecurity,
    },

    {
      title: "Certificate in Photo Editing",
      duration: "120",
      nsqfLevel: "3",
      qpCode: " 2019/ME/HKCL/3546",
      link: "https://hkcl.in/University/hcoc_photo_editing.php",
      image: PhotoEditing,
    },

    {
      title: "Certificate in Video Editing",
      duration: "120",
      nsqfLevel: "3",
      qpCode: "2019/ME/HKCL/3547",
      link: "https://hkcl.in/University/hcoc_video_editing.php",
      image: VideoEditing,
    },
    {
      title: "Certificate in Graphic Designing",
      duration: "120",
      nsqfLevel: "3",
      qpCode: "2019/ITES/HKCL/3556",
      link: "https://hkcl.in/University/hcoc_graphic_designing.php",
      image: GraphicDesigning,
    },
    {
      title: "Certificate in CorelDraw (DTP)",
      duration: "120",
      nsqfLevel: "3",
      qpCode: "2019/ITES/HKCL/3560",
      link: "https://hkcl.in/University/hcoc_dtp_corel",
      image: CorelDraw,
    },

    {
      title: "Certificate in Adobe (DTP)",
      duration: "132",
      nsqfLevel: "3",
      qpCode: "2019/ITES/HKCL/3560",
      link: "https://hkcl.in/University/hcoc_dtp_adobe",
      image: adobeDTP,
    },

    {
      title: "Certificate in Web Designing",
      duration: "132",
      nsqfLevel: "4",
      qpCode: "2019/ITES/HKCL/3562",
      link: "https://hkcl.in/University/hcoc_web_designing.php",
      image: WebDesigning,
    },

    {
      title: "Certificate in AutoCAD",
      duration: "120",
      nsqfLevel: "4",
      qpCode: "2019/ITES/HKCL/3554",
      link: "https://hkcl.in/University/hcoc_autocad.php",
      image: AutoCAD,
    },

    {
      title: "Certificate in Office Assistance",
      duration: "120",
      nsqfLevel: "3",
      qpCode: "2019/OAFM/HKCL/3549",
      link: "https://hkcl.in/University/hcoc_office_assistance.php",
      image: OfficeAssistance,
    },

    {
      title: "Certificate  in C#",
      duration: "120",
      nsqfLevel: "4",
      qpCode: "2019/ITES/HKCL/3555",
      link: "https://hkcl.in/University/hcoc_c_sharp.php",
      image: CProgramming,
    },




    {
      title: "Certificate in PHP",
      duration: "120",
      nsqfLevel: "4",
      qpCode: "2019/ITES/HKCL/3555",
      link: "https://hkcl.in/University/hcoc_php.php",
      image: CProgramming,
    },
    {
      title: "Certificate in Python",
      duration: "120",
      nsqfLevel: "4",
      qpCode: "2019/ITES/HKCL/3555",
      link: "https://hkcl.in/University/hcoc_python.php",
      image: CProgramming,
    },
    {
      title: "Certificate in Java",
      duration: "120",
      nsqfLevel: "4",
      qpCode: "2019/ITES/HKCL/3555",
      link: "https://hkcl.in/University/hcoc_java.php",
      image: CProgramming,
    },



    {
      title: "Certificate in Digital Freelancing",
      duration: "60",
      nsqfLevel: "4",
      qpCode: "2019/ITES/HKCL/3555",
      link: "https://hkcl.in/University/hcoc_digital_freelancing.php",
      image: CProgramming,
    },


    {
      title: "Certificate in Retail Management",
      duration: "120",
      nsqfLevel: "4",
      qpCode: "2019/ITES/HKCL/3555",
      link: "https://hkcl.in/University/hcoc_retail_management.php",
      image: CProgramming,
    },
    {
      title: "Certificate  in HTML with CSS",
      duration: "120",
      nsqfLevel: "4",
      qpCode: "2019/ITES/HKCL/3555",
      link: "https://hkcl.in/University/hcoc_html_css.php",
      image: CProgramming,
    },


    {
      title: "Certificate in Data Entry and Data Management",
      duration: "120",
      nsqfLevel: "4",
      qpCode: "2019/ITES/HKCL/3555",
      link: "https://hkcl.in/University/hcoc_data_entry.php",
      image: CProgramming,
    },

    {
      title: "Certificate  in Database Management System (DBMS)",
      duration: "120",
      nsqfLevel: "4",
      qpCode: "2019/ITES/HKCL/3555",
      link: "https://hkcl.in/University/hcoc_dbms.php",
      image: CProgramming,
    },

    {
      title: "Certificate  in Data Structures using C and C++",
      duration: "120",
      nsqfLevel: "4",
      qpCode: "2019/ITES/HKCL/3555",
      link: "",
      image: CProgramming,
    },



    {
      title: "Certificate in C and C++ Programming",
      duration: "120",
      nsqfLevel: "4",
      qpCode: "2019/ITES/HKCL/3555",
      link: "https://hkcl.in/University/hcoc_c.php",
      image: CProgramming,
    },

    {
      title: "Certificate  in Banking, Financial Services and Insurance (BFSI)",
      duration: "120",
      nsqfLevel: "4",
      qpCode: "2019/ITES/HKCL/3555",
      link: "https://hkcl.in/University/hcoc_bfsi.php",
      image: FinancialAccounting,
    },


    {
      title: "Certificate in Advanced Tally (with latest version of Tally Prime)",
      duration: "120",
      nsqfLevel: "4",
      qpCode: "2019/ITES/HKCL/3555",
      link: "",
      image: FinancialAccounting,
    },

    {
      title: "Certificate in Social Media Marketing",
      duration: "60",
      nsqfLevel: "4",
      qpCode: "2019/ITES/HKCL/3555",
      link: "",
      image: FinancialAccounting,
    },


  ];

  const handleReadMore = (link) => {
    setIframeSrc(link);
  };

  return (
    <div>
      <div className="row">
        {courses.map((course, index) => (
          <Col md={3} xs={12} key={index}>
            <Card className="m-2" style={{ borderRadius: "8px", boxShadow: "0 4px 8px rgba(0,0,0,0.1)", minHeight: "470px" }}>
              <CardHeader className="text-center" style={{ backgroundColor: "white", padding: "10px" }}>
                <img src={course.image} alt="img" style={{ maxWidth: "100%" }} />
              </CardHeader>
              <CardBody style={{ display: "flex", flexDirection: "column", padding: "10px" }}>
                <CardText style={{ fontSize: "14px", flexGrow: 1 }}>
                  <div className="text-center" style={{ fontWeight: "bold", fontSize: "16px", marginBottom: "15px", textDecoration: "underline" }}>
                    {course.title}
                  </div>
                  <div style={{ marginTop: "15px", textAlign: "left" }}>
                    <div style={{ marginBottom: "12px", fontSize: "14px" }}>
                      <strong>Duration (in hours):</strong> <span>{course.duration}</span>
                    </div>
                    <div style={{ marginBottom: "12px", fontSize: "14px" }}>
                      <strong>Language: </strong>English
                    </div>
                    <div style={{ marginBottom: "12px", fontSize: "14px" }}>
                      <strong>Learning Mode: </strong>Online
                    </div>
                    <div style={{ marginBottom: "12px", fontSize: "14px" }}>
                      <strong>Completion Certificate </strong>by GJU & HKCL
                    </div>
                  </div>
                </CardText>
                <Button
                  className="btn btn-primary b1 mt-1"
                  style={{
                    backgroundColor: "#6a73fa",
                    fontSize: "14px",
                    padding: "8px 15px",
                    borderRadius: "4px",
                    marginTop: "auto", // This pushes the button to the bottom
                    width: "100%",
                  }}
                  onClick={() => handleReadMore(course.link)}
                >
                  Read More
                </Button>
              </CardBody>
            </Card>
          </Col>

        ))}
      </div>


      {iframeSrc && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(255, 255, 255, 0.9)",
            zIndex: 1000,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              position: "relative",
              width: "80%",
              height: "80%",
              backgroundColor: "white",
              borderRadius: "8px",
              overflow: "hidden",
              boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)",
            }}
          >

            <Button
              className="btn btn-danger"
              style={{
                position: "absolute",
                top: "10px",
                right: "20px",
                zIndex: 1100,
              }}
              onClick={() => setIframeSrc("")}
            >
              ×
            </Button>

            {/* Iframe */}
            <iframe
              src={iframeSrc}
              title="Course Details"
              style={{
                width: "100%",
                height: "100%",
                border: "none",
              }}
            />
          </div>
        </div>
      )}
    </div>

  );
};

export default CourseCard;
